import { Grid, TextField } from "@mui/material";
import type { Control, UseFormRegister, UseFormWatch } from "react-hook-form";
import SelectAccountListByMethod from "src/common/SelectAccountListByMethod";
import type { IB2B_Invoice } from "../type/b2bType";
import B2BSelectFieldList from "../B2BSelectFieldList";
import InvoiceB2BSelectFieldList from "../b2binvoice/InvoiceB2BSelectFieldList";
type IProps = {
	register: UseFormRegister<any>;
	watch: UseFormWatch<any>;
	control?: Control<any, any>;
	invoiceDetails?: IB2B_Invoice;
};
const B2BMoneyReceiptForm = ({
	watch,
	control,
	register,
	invoiceDetails,
}: IProps) => {
	return (
		<Grid container spacing={2}>
			{invoiceDetails?.b2b_first_name ? (
				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						disabled
						value={
							invoiceDetails?.b2b_first_name +
							invoiceDetails?.b2b_last_name
						}
					/>
				</Grid>
			) : (
				<Grid item xs={12} sm={6}>
					<B2BSelectFieldList
						mt='0'
						fieldName='b2b_id'
						register={register}
						isRequired
						hideCustomLabel
					/>
				</Grid>
			)}

			{invoiceDetails?.invoice_no ? (
				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						disabled
						value={invoiceDetails?.invoice_no}
					/>
				</Grid>
			) : (
				<Grid item xs={12} sm={6}>
					<InvoiceB2BSelectFieldList
						mt='0'
						fieldName='invoice_id'
						register={register}
						isRequired
						hideCustomLabel
						watch={watch}
					/>
				</Grid>
			)}

			<SelectAccountListByMethod
				register={register}
				md={12}
				lg={6}
				watch={watch}
				control={control}
			/>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Payment Date'
					type='date'
					InputLabelProps={{ shrink: true }}
					{...register("payment_date", {
						required: {
							value: true,
							message: "Please, Provide an account name!",
						},
					})}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Amount'
					type='number'
					defaultValue={invoiceDetails?.due}
					{...register("amount")}
				/>
			</Grid>

			{/* <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label='Bank Name'
                        {...register("bank_name")}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label='Cheque No'
                        {...register("cheque_no")}
                    />
                </Grid> */}

			<Grid item xs={12}>
				<TextField
					fullWidth
					label='Note'
					multiline
					rows={4}
					placeholder='Write additional details (optional)...'
					{...register("note")}
				/>
			</Grid>
		</Grid>
	);
};

export default B2BMoneyReceiptForm;
